import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipeCapitalizePipe } from './pipe-capitalize.pipe'

@NgModule({
  imports: [CommonModule],
  declarations: [PipeCapitalizePipe],
  exports:[ PipeCapitalizePipe]
})
export class PipeCapitalizeModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/pipe-capitalize/pipe-capitalize.module.ts